import React from 'react';
import { useLocalizedStrings } from '../../../Localization';
import { ContactCard } from '@aidkitorg/component-library';

interface ProgramContactsProps {
  contacts?: Array<{
    name: string;
    title: string;
    email: string;
  }>;
}

export const ProgramContacts: React.FC<ProgramContactsProps> = ({ contacts }) => {
  const L = useLocalizedStrings()

  const programContacts = contacts

  if (!programContacts || programContacts.length == 0) {
    return <></>
  }

  const contactCards = programContacts.map((contact, idx) => (
    <ContactCard
      key={idx}
      name={contact.name}
      title={contact.title}
      icon="EnvelopeIcon"
      onIconClick={() => window.location.href = "mailto:"+contact.email}
    />
  ))

  return (
    <>
      <hr />
      <div>
        <div className="font-semibold">{L.admin_panel.program_home.quick_actions.program_contacts}</div>
        <div className="flex flex-col gap-y-4 pt-3">
          {contactCards}
        </div>
      </div>
    </>
  )
}